import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'
import { useState } from 'react'

import { useAppStore } from '@src/app/context'
import AddParticipantController from '@src/app/voice/store/AddParticipantController'
import CallTransferController from '@src/app/voice/store/CallTransferController'
import useStore from '@src/lib/hooks/useStore'
import type { ActiveCall } from '@src/service/voice'

import { CallContext } from './CallContext'

interface CallProviderProps {
  call: ActiveCall
}

const CallProvider = observer(
  ({ call, children }: PropsWithChildren<CallProviderProps>) => {
    const app = useAppStore()
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
    const addParticipantController = useStore(
      () => new AddParticipantController(app, call),
      [],
    )
    const transferController = useStore(() => new CallTransferController(app, call), [])

    return (
      <CallContext.Provider
        value={{
          addParticipantController,
          transferController,
          call,
          openConfirmationModal,
          setOpenConfirmationModal,
        }}
      >
        {children}
      </CallContext.Provider>
    )
  },
)

export default CallProvider
